import { RouteConfig } from 'vue-router';
import { tryParseInt } from '@witkac/utils/tryParseInt';

import store from '@/store';
import { PublicSettings, StateString } from '@witkac/kartamiejska-shared';

export const eventDetailsRoute: RouteConfig = {
  path: ':id',
  component: () => import(/* webpackChunkName: "EventDetails" */ '@/views/main/event/Details.vue'),
  name: 'eventDetails',
  meta: {
    nested: true
  },
  beforeEnter(to, _from, next) {
    Promise.all([
      store.dispatch('benefit/get', tryParseInt(to.params.id)),
      store.dispatch('settings/get', PublicSettings.NO_GROUP_SELECTED_NAME)
    ]).then(([benefit, _setting]) => {
      if (benefit.state !== StateString.ACTIVE) {
        return next({ name: 'events' });
      }
      if (benefit.place) {
        return store.dispatch('place/get', tryParseInt(benefit.place.id)).then(() => next());
      }
      next();
    });
  }
};
